module.exports = __webpack_public_path__ + "../resources/img/ic_linked_p2.c134a15e.svg";